import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'spinner-oficina-virtual',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {

  @Input() loadingImage: string;
  @Input() show = false;
  @Input() text = '';
  @Input() widthImage : number;
  @Input() sizeText : string;

  constructor() { }

  ngOnInit() {
    if (!this.loadingImage) throw new Error("No se ha podido cargar la imagen.");
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/spinner/spinner.component.ts